module.exports = "<div class=\"card\">\n\t<div class=\"card-body nap-title\">\n        <fac-editables-form></fac-editables-form>\n    </div>\n</div>"